import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$complaint, _vm$complaint2, _vm$complaint3, _vm$complaint$handler;
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.title,
      visible: _vm.visible,
      width: "600px",
      "before-close": _vm.handleClose,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("el-form", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "form",
    staticClass: "resolve-form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "102px"
    }
  }, [((_vm$complaint = _vm.complaint) === null || _vm$complaint === void 0 ? void 0 : _vm$complaint.statusV2) === "RESOLVED" || ((_vm$complaint2 = _vm.complaint) === null || _vm$complaint2 === void 0 ? void 0 : _vm$complaint2.statusV2) === "SUSPENDED" && _vm.mode === "view" ? _c("div", {
    staticClass: "resolve-section wlc-f-c mb24px"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("结案时间")]), _c("div", {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")((_vm$complaint3 = _vm.complaint) === null || _vm$complaint3 === void 0 ? void 0 : _vm$complaint3.closeAt, "YYYY-MM-DD HH:mm")))]), _c("div", {
    staticClass: "label"
  }, [_vm._v("操作人")]), _c("div", {
    staticClass: "content"
  }, [_vm._v(_vm._s(((_vm$complaint$handler = _vm.complaint.handler) === null || _vm$complaint$handler === void 0 ? void 0 : _vm$complaint$handler.adminName) || ""))])]) : _vm._e(), _c("div", {
    staticClass: "resolve-section wlc-f-c"
  }, [_c("div", {
    staticClass: "label font-500 !color-#5B9CF8"
  }, [_vm._v("投诉人")]), _c("div", {
    staticClass: "content user-info wlc-f-c"
  }, [_c("wlc-image", {
    staticClass: "avatar",
    attrs: {
      src: _vm.complainant.avatar,
      width: "24",
      height: "24",
      enlarged: false
    }
  }), _c("span", {
    staticClass: "name ml-2"
  }, [_vm._v(_vm._s(_vm.complainant.name))])], 1)]), _c("div", {
    staticClass: "resolve-section wlc-f-c"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("奖励发放")]), _c("div", {
    staticClass: "content"
  }, [_c("el-checkbox", {
    attrs: {
      disabled: _vm.mode === "view"
    },
    model: {
      value: _vm.form.actions.reward,
      callback: function callback($$v) {
        _vm.$set(_vm.form.actions, "reward", $$v);
      },
      expression: "form.actions.reward"
    }
  }, [_vm._v("奖励投诉发起人")])], 1)]), _vm.mode !== "view" ? _c("div", {
    staticClass: "resolve-section wfull mb24px"
  }, [_c("el-form-item", {
    staticClass: "wfull",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "发送消息",
      prop: "replyText"
    }
  }, [_c("wlc-at-mention-input", {
    staticClass: "wfull",
    attrs: {
      type: "textarea",
      rows: 4,
      placeholder: "输入@+关键词唤醒快捷回复。请输入要发送给投诉人的消息。",
      maxlength: "100",
      "show-word-limit": "",
      advisoryId: _vm.currentId
    },
    model: {
      value: _vm.form.replyText,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "replyText", $$v);
      },
      expression: "form.replyText"
    }
  })], 1)], 1) : _c("div", [_c("el-form-item", {
    attrs: {
      label: "结案备注"
    }
  }, [_c("div", {
    style: {
      color: !_vm.form.replyText ? "#B7B7B7" : "inherit"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.replyText || "未填写") + " ")])])], 1), !_vm.isExpanded ? _c("div", {
    staticClass: "toggle-section",
    on: {
      click: function click($event) {
        _vm.isExpanded = !_vm.isExpanded;
      }
    }
  }, [_c("span", [_vm._v("被投诉人处理结果")]), _c("i", {
    staticClass: "el-icon-arrow-down"
  })]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isExpanded,
      expression: "isExpanded"
    }],
    staticClass: "mt-30px"
  }, [_c("div", {
    staticClass: "resolve-section"
  }, [_c("div", {
    staticClass: "label font-500 !color-#5B9CF8"
  }, [_vm._v("被投诉人")]), _c("div", {
    staticClass: "content user-info wlc-f-c"
  }, [_c("wlc-image", {
    staticClass: "avatar",
    attrs: {
      src: _vm.complained.avatar,
      width: "24",
      height: "24",
      enlarged: false
    }
  }), _c("span", {
    staticClass: "name ml-2"
  }, [_vm._v(_vm._s(_vm.complained.name))])], 1)]), _c("div", {
    staticClass: "resolve-section"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("禁言措施")]), _c("div", {
    staticClass: "content"
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.mode === "view"
    },
    model: {
      value: _vm.form.actions.mute,
      callback: function callback($$v) {
        _vm.$set(_vm.form.actions, "mute", $$v);
      },
      expression: "form.actions.mute"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("无")]), _c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("禁言3天")]), _c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("永久禁言")]), _c("el-radio", {
    attrs: {
      label: 3
    }
  }, [_vm._v("诈骗禁言")])], 1)], 1)]), _vm.mode !== "view" ? _c("div", {
    staticClass: "resolve-section wfull"
  }, [_c("el-form-item", {
    staticClass: "wfull",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "发送消息",
      prop: "complainedMessage"
    }
  }, [_c("wlc-at-mention-input", {
    staticClass: "wfull",
    attrs: {
      type: "textarea",
      rows: 4,
      placeholder: "输入@+关键词唤醒快捷回复。请输入要发送给被投诉人的消息，留空则不提示。",
      maxlength: "100",
      advisoryId: _vm.currentId,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.complainedMessage,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "complainedMessage", $$v);
      },
      expression: "form.complainedMessage"
    }
  })], 1)], 1) : _c("div", [_c("el-form-item", {
    attrs: {
      label: "结案备注"
    }
  }, [_c("div", {
    style: {
      color: !_vm.form.complainedMessage ? "#B7B7B7" : "inherit"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.complainedMessage || "未填写") + " ")])])], 1), _vm.isExpanded ? _c("div", {
    staticClass: "toggle-section",
    on: {
      click: function click($event) {
        _vm.isExpanded = !_vm.isExpanded;
      }
    }
  }, [_c("span", [_vm._v("收起")]), _c("i", {
    staticClass: "el-icon-arrow-up"
  })]) : _vm._e()])]), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_vm.mode !== "view" ? [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      loading: _vm.submitLoading
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v("提 交")])] : [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭窗口")])]], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };